import { useEffect } from 'react';
import { useOpenModal } from '../next-modal';
import { isBuildIn } from '../build-in';

export const useOpenExternLink = () => {
  const openModal = useOpenModal();
  useEffect(() => {
    const isExternalLink = (url: string): boolean => {
      try {
        const currentHost = window.location.host;
        const targetHost = new URL(url, window.location.href).host;
        return currentHost !== targetHost;
      } catch {
        return true;
      }
    };

    const handleDocumentClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const anchor = target.closest('a'); // 获取最近的a标签
      if (!anchor) return;

      const { href } = anchor;
      if (!href || !isExternalLink(href)) return;

      // 检查是否需要跳过确认
      if (anchor.dataset.bypassCheck) return;

      // 阻止默认行为和事件传播
      event.preventDefault();
      event.stopImmediatePropagation();

      openModal.warning({
        title: <span className="text-red">安全警告</span>,
        colorType: 'active',
        confirmText: '坚持访问',
        //不知道为啥本地可以用翻译但build之后就不行，这里做下特殊对待
        content: (
          <div className="my-2.5 text-t2 w-full whitespace-pre-line break-words max-h-[50vh] overflow-y-auto">
            <div>
              您将访问外部网站<span>{href}</span>
            </div>
            <div>
              FlowUs不对其他网站的内容及其真实性负责，请确认该网站的可信度，保护好您的个人信息及财产安全。
            </div>
          </div>
        ),
        confirm() {
          // 判断打开方式（新标签/当前页）
          const openInNewTab =
            anchor.target === '_blank' || event.ctrlKey || event.metaKey || event.button === 1; // 中键点击

          if (openInNewTab) {
            window.open(href, '_blank');
          } else {
            window.location.href = href;
          }
        },
      });
    };

    // 捕获阶段监听点击事件
    document.addEventListener('click', handleDocumentClick, true);

    return () => {
      document.removeEventListener('click', handleDocumentClick, true);
    };
  }, [openModal]);
};
